module.exports = __webpack_public_path__ + "media/images/web_suite/dashboard/labs_icon-e850f364c883e8939224ed2b2cee140d.png";